import React, { Component } from "react";
import Router from "next/router";
import { Row, Col,Empty,Icon,message } from "antd";
import moment from "moment";
import Countdown from "react-countdown";
import ImageWithFallback from "@/ImageWithFallback/";
import { PromotionList } from "$ACTIONS/cmsApi";
import { isWebPSupported, getQueryVariable } from "$ACTIONS/helper";
import { translate } from "$ACTIONS/Translate";
import DetailModal from "@/Dailydeals/modal";

class DailyRewards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            DailyList: [],
            ShowDetail: false,
            BonusData:[]
        };
    }
    componentDidMount() {
        this.getDailydealsList(true);
    }
    componentWillUnmount() {
        this.setState = () => false;
    }
    //判斷是否由 Banner 跳轉
    isFromBanner = () => {
        const id = getQueryVariable("id");
        const jumpfrom = getQueryVariable("jumpfrom");
        const isFromBanner = id && jumpfrom === "BANNER"; // 是否由 Banner 跳轉
        return isFromBanner;
    };
    //获取每日优惠
    getDailydealsList = (isLoad) => {
        this.props.setLoading(true)
        let params = {
            type: "daily",
        };
        PromotionList(params).then((res) => {
            if (res) {
                this.setState({
                    DailyList: res
                });
                const isFromBanner = this.isFromBanner();
                if (isFromBanner) {
                    const id = getQueryVariable("id");
                    const data = res.find((item) => item.promoId === id);
                    if (data) {
                        this.setState({
                            ShowDetail: true,
                            BonusData: data,
                        });
                    } else {
                        Router.push("/");
                        message.error(translate("暂时没有优惠"));
                    }
                }
                if (isLoad) {
                    this.props.setLoading(false)
                }
            }
        }).finally(() => {
            this.props.setLoading(false)
        })
    };

    render() {
        const {
            DailyList,
            ShowDetail,
            BonusData,
        } = this.state;
        const renderer = ({ days, hours, minutes, seconds, completed }) => {
            if (completed) {
                return <span>0 {translate("时")} 0 {translate("分")}</span>;
            } else {
                return (
                    <span>
                        {days} {translate("天")} {hours} {translate("时")} {minutes} {translate("分")}
                    </span>
                );
            }
        };
        return (
            <div className="daily-rewards">
                <Row gutter={16}>
                    {DailyList?.length && Array.isArray(DailyList) ? DailyList.map((item, i) => {
                        return (
                            <Col span={8} key={item.promoId +i}>
                                <div
                                    className="daily-deals-list"
                                    style={{
                                        marginBottom:
                                            "35px",
                                    }}
                                >
                                    <div
                                        className="daily-deals-list-img"
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            this.setState(
                                                {
                                                    ShowDetail: true,
                                                    BonusData:
                                                        item,
                                                }
                                            );
                                        }}
                                    >
                                        <ImageWithFallback
                                            src={
                                                item.promoImage
                                            }
                                            width={354}
                                            height={166}
                                            alt={
                                                item.promoTitle
                                            }
                                            fallbackSrc="/vn/img/logo/logo.svg"
                                        />
                                        <div className="daily-deals-item">
                                            <div className="daily-deals-item-left">
                                                <div className="daily-deals-item-left-title">
                                                    <h5>
                                                        {
                                                            item.promoTitle
                                                        }
                                                    </h5>
                                                </div>

                                                <div className="daily-deals-item-left-info">
                                                    <div className="daily-deals-item-left-icon">
                                                        <Icon type="clock-circle" style={{color:"#999"}}/>
                                                    </div>

                                                    <div className="daily-deals-item-left-text">
                                                        <Countdown
                                                            daysInHours={
                                                                true
                                                            }
                                                            date={
                                                                new Date(
                                                                    item.endDate
                                                                )
                                                            }
                                                            renderer={
                                                                renderer
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {item.bonusData ? (
                                                <div className="daily-deals-item-btn">
                                                    {item.bonusData.currentApplications >= item.bonusData.maxApplications ? (
                                                        <button className="out-of-stock">
                                                            {translate("缺货")}{" "}
                                                        </button>
                                                    ) : (
                                                        <button>
                                                            {translate("剩余")}{" "}
                                                            {item.bonusData.maxApplications - item.bonusData.currentApplications}
                                                        </button>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="daily-deals-item-btn">
                                                    <button>
                                                        {translate("没有数据")}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        );
                    })
                    :<Col span={24} style={{marginTop:"200px"}}>
                        <Empty
                            image={"/vn/img/icon/img-no-record.svg"}
                            className="big-empty-box"
                            description={translate("每日好礼数据为空")}
                        />
                    </Col>}
                </Row>
                {/*-------------------- 打开优惠详情 --------------------*/}
                {ShowDetail && (
                    // <div className="PromoDetail">
                        <DetailModal
                            BonusData={BonusData}
                            ShowDetail={ShowDetail}
                            CloseDetail={() => {
                                this.setState({
                                    ShowDetail: false,
                                });
                            }}
                        />
                    // </div>
                )}
            </div>
        );
    }
}

export default DailyRewards;